import {
  SET_FIRST_DAY_OF_WEEK,
  SET_LOCALISATION_VARS,
  SET_TRANSLATIONS,
} from '../helpers/constants/actionsConstants';

import type { LocalisationAction } from '../actions/types';
import type { LocalisationState } from '../selectors/types';

const initialState: LocalisationState = {
  translations: {},
  locale: 'en-GB',
  currency: 'GBP',
  market: 'UK',
  firstDayOfWeek: 1,
};

const reducer = (
  state: LocalisationState = initialState,
  action: LocalisationAction,
): LocalisationState => {
  switch (action.type) {
    case SET_TRANSLATIONS:
      return {
        ...state,
        translations: action.payload,
      };

    case SET_LOCALISATION_VARS: {
      const { currency, locale, market } = action.payload;

      return {
        ...state,
        locale,
        market,
        currency,
      };
    }

    case SET_FIRST_DAY_OF_WEEK:
      return {
        ...state,
        firstDayOfWeek: action.payload,
      };

    default:
      return state;
  }
};

export { initialState };

export default reducer;
